export default __webpack_public_path__ + "static/media/LogoPokerReloadedForPCR.fff33631.png";